import { ComponentProps, FC, useCallback, useState } from 'react'
import { Select } from 'antd'
import cn from 'classnames'
import { ClassFieldsProps } from '../../ClassFields'
import classes from './index.module.css'
import aiclasses from '@pages/Admin/CRM/styles/activeIcon.module.css'
import { EditOutlined } from '@ant-design/icons'
import CreateClassesModalWrapper from './components/CreateClassesModalWrapper/CreateClassesModalWrapper'
import EditClassesModal from './components/EditClassesModal/EditClassesModal'
import type { SelectProps } from 'antd';
interface SelectClassProps
  extends Pick<
    ComponentProps<typeof Select>,
    'onChange' | 'value' | 'className' | 'popupClassName'
  > {
  classesState: ClassFieldsProps['classesState']
}

type FilterOption = SelectProps['filterOption'];

const filterOptionsByLabel: FilterOption = (input, option) => 
  ((option?.labelString as string) ?? '').toLowerCase().includes(input.toLowerCase());

const SelectClass: FC<SelectClassProps> = ({
  className,
  popupClassName,
  classesState,
  onChange,
  ...rest
}) => {
  const [selectOpen, setSelectOpen] = useState(false)
  const [stateModal, setStateModal] = useState<{
    open: boolean
    type?: 'create' | 'edit'
    classId?: number
  }>({
    open: false,
    type: 'create',
  })

  const filterSort = useCallback((optionA: any, optionB: any) => {
    if (optionA?.value === 'ACTION_CREATE_CLASS') return -1
    if (optionB?.value === 'ACTION_CREATE_CLASS') return 1

    return (optionA?.labelString ?? '')
      .toLowerCase()
      .localeCompare((optionB?.labelString ?? '').toLowerCase())
  }, [])

  return (
    <>
      <Select
        showSearch
        filterOption={filterOptionsByLabel}
        open={selectOpen}
        onDropdownVisibleChange={setSelectOpen}
        className={cn(className, classes.selectWithCreateButton)}
        popupClassName={cn(popupClassName, classes.selectWithCreateButton)}
        placeholder="Выберите класс"
        optionFilterProp="label"
        options={[
          {
            label: 'Создать класс',
            value: 'ACTION_CREATE_CLASS',
            'data-create-element': true,
          },
          ...(classesState.value?.map(({ title: label, id: value }) => ({
            value,
            label: (
              <div className={classes.elementWrapper}>
                <p>{label}</p>
                <EditOutlined
                  className={cn(aiclasses.activeIcon, classes.elementEditIcon)}
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                  onClick={(event) => {
                    event.stopPropagation()
                    setSelectOpen(false)
                    setStateModal({ open: true, type: 'edit', classId: value })
                  }}
                />
              </div>
            ),
            labelString: label,
          })) || []),
        ]}
        loading={classesState.loading}
        filterSort={filterSort}
        onChange={(val, option) => {
          if (val === 'ACTION_CREATE_CLASS') {
            setStateModal({ open: true, type: 'create' })
          } else {
            onChange?.(val, option)
          }
        }}
        {...rest}
      />

      {/* Modals */}
      <CreateClassesModalWrapper
        open={stateModal.open && stateModal.type === 'create'}
        onClose={() => setStateModal({ open: false })}
        onSuccess={(classId) => {
          classesState.retry()
          // @ts-ignore
          onChange?.(classId)
          setStateModal({ open: true, type: 'edit', classId })
        }}
      />
      <EditClassesModal
        classId={stateModal.classId}
        open={stateModal.open && stateModal.type === 'edit'}
        onClose={() => setStateModal({ open: false })}
        onSuccess={() => {
          classesState.retry()
          setStateModal({ open: false })
        }}
      />
    </>
  )
}

export default SelectClass
